/* Native details remain usable without JS; this adds pointer and keyboard convenience. */
if (!customElements.get('ce-model-nav')) {
  customElements.define('ce-model-nav', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.items = [...this.querySelectorAll('.ce-model-nav__details')];
      const close = (except = null) => this.items.forEach(item => {
        if (item !== except) {
          item.open = false;
          item.querySelector('summary').setAttribute('aria-expanded', 'false');
        }
      });
      this.close = close;
      this.items.forEach(item => {
        const trigger = item.querySelector('summary');
        trigger.setAttribute('aria-expanded', String(item.open));
        item.addEventListener('toggle', () => {
          trigger.setAttribute('aria-expanded', String(item.open));
          if (item.open) close(item);
        }, options);
        item.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
          clearTimeout(this.closeTimer);
          close(item);
          item.open = true;
          trigger.setAttribute('aria-expanded', 'true');
        }, options);
        item.addEventListener('pointerleave', () => {
          this.closeTimer = setTimeout(() => {
            if (!item.contains(document.activeElement)) {
              item.open = false;
              trigger.setAttribute('aria-expanded', 'false');
            }
          }, 180);
        }, options);
        trigger.addEventListener('keydown', event => {
          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
          event.preventDefault();
          clearTimeout(this.closeTimer);
          close(item);
          item.open = true;
          trigger.setAttribute('aria-expanded', 'true');
          const links = [...item.querySelectorAll('a[href]')];
          const target = event.key === 'ArrowDown' ? links[0] : links[links.length - 1];
          target?.focus();
        }, options);
      });
      this.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = this.items.find(item => item.open);
        if (!open) return;
        event.preventDefault();
        close();
        open.querySelector('summary').focus();
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) close();
      }, options);
      window.addEventListener('resize', () => {
        if (window.innerWidth < 990) close();
      }, options);
    }
    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
